module.exports = /******/
function(modules) {
    /******/
    /******/
    // The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/
        /******/
        // Check if module is in cache
        /******/
        if (installedModules[moduleId]) /******/
        return installedModules[moduleId].exports;
        /******/
        /******/
        // Create a new module (and put it into the cache)
        /******/
        var module = installedModules[moduleId] = {
            /******/
            exports: {},
            /******/
            id: moduleId,
            /******/
            loaded: !1
        };
        /******/
        /******/
        // Return the exports of the module
        /******/
        /******/
        /******/
        // Execute the module function
        /******/
        /******/
        /******/
        // Flag the module as loaded
        /******/
        return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
        module.loaded = !0, module.exports;
    }
    // webpackBootstrap
    /******/
    // The module cache
    /******/
    var installedModules = {};
    /******/
    /******/
    // Load entry module and return exports
    /******/
    /******/
    /******/
    /******/
    // expose the modules object (__webpack_modules__)
    /******/
    /******/
    /******/
    // expose the module cache
    /******/
    /******/
    /******/
    // __webpack_public_path__
    /******/
    return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
    __webpack_require__.p = "", __webpack_require__(0);
}([ /* 0 */
/***/
function(module, exports, __webpack_require__) {
    module.exports = __webpack_require__(5);
}, /* 1 */
, /* 2 */
, /* 3 */
, /* 4 */
, /* 5 */
/***/
function(module, exports, __webpack_require__) {
    "use strict";
    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }
    Object.defineProperty(exports, "__esModule", {
        value: !0
    });
    var _defineProperty2 = __webpack_require__(6), _defineProperty3 = _interopRequireDefault(_defineProperty2), _getPrototypeOf = __webpack_require__(7), _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf), _classCallCheck2 = __webpack_require__(8), _classCallCheck3 = _interopRequireDefault(_classCallCheck2), _createClass2 = __webpack_require__(9), _createClass3 = _interopRequireDefault(_createClass2), _possibleConstructorReturn2 = __webpack_require__(10), _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2), _inherits2 = __webpack_require__(11), _inherits3 = _interopRequireDefault(_inherits2), _classnames = __webpack_require__(12), _classnames2 = _interopRequireDefault(_classnames), _react = __webpack_require__(13), _react2 = _interopRequireDefault(_react), _style = __webpack_require__(14), _style2 = _interopRequireDefault(_style), APPEARANCE_ENUM = {
        values: [ "default", "success", "removed", "inprogress", "new", "moved" ],
        defaultValue: "default"
    }, Lozenge = function(_PureComponent) {
        function Lozenge() {
            return (0, _classCallCheck3.default)(this, Lozenge), (0, _possibleConstructorReturn3.default)(this, (Lozenge.__proto__ || (0, 
            _getPrototypeOf2.default)(Lozenge)).apply(this, arguments));
        }
        return (0, _inherits3.default)(Lozenge, _PureComponent), (0, _createClass3.default)(Lozenge, [ {
            key: "validAppearance",
            // returns the assigned appearance if valid, falling back to the default otherwise
            value: function() {
                var appearance = this.props.appearance, values = APPEARANCE_ENUM.values, defaultValue = APPEARANCE_ENUM.defaultValue;
                return values.indexOf(appearance) !== -1 ? appearance : defaultValue;
            }
        }, {
            key: "render",
            value: function() {
                var _props = this.props, isBold = _props.isBold, children = _props.children, classes = (0, 
                _classnames2.default)([ (0, _defineProperty3.default)({}, _style2.default.bold, isBold), _style2.default.lozenge, _style2.default[this.validAppearance()] ]);
                return _react2.default.createElement("span", {
                    className: classes
                }, _react2.default.createElement("span", {
                    className: _style2.default.content
                }, children));
            }
        } ]), Lozenge;
    }(_react.PureComponent);
    Lozenge.propTypes = {
        isBold: _react.PropTypes.bool,
        appearance: _react.PropTypes.oneOf(APPEARANCE_ENUM.values),
        children: _react.PropTypes.node
    }, Lozenge.defaultProps = {
        isBold: !1,
        appearance: APPEARANCE_ENUM.defaultValue
    }, exports.default = Lozenge;
}, /* 6 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/defineProperty");
}, /* 7 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/core-js/object/get-prototype-of");
}, /* 8 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/classCallCheck");
}, /* 9 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/createClass");
}, /* 10 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/possibleConstructorReturn");
}, /* 11 */
/***/
function(module, exports) {
    module.exports = require("babel-runtime/helpers/inherits");
}, /* 12 */
/***/
function(module, exports) {
    module.exports = require("classnames");
}, /* 13 */
/***/
function(module, exports) {
    module.exports = require("react");
}, /* 14 */
/***/
function(module, exports, __webpack_require__) {
    // style-loader: Adds some css to the DOM by adding a <style> tag
    // load the styles
    var content = __webpack_require__(15);
    "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
    // add the styles to the DOM
    __webpack_require__(17)(content, {});
    content.locals && (module.exports = content.locals);
}, /* 15 */
/***/
function(module, exports, __webpack_require__) {
    exports = module.exports = __webpack_require__(16)(), // imports
    // module
    exports.push([ module.id, "._1L7JuuVj2lrlA-uLiXZjNZ{border-radius:3px;box-sizing:border-box;display:-webkit-inline-box;display:inline-flex;font-size:11px;font-weight:700;line-height:1;max-width:200px;padding:2px 4px 3px;text-transform:uppercase;vertical-align:baseline;white-space:nowrap}._2PDIjPIcgtZboLS2A1XsP6{display:inline-block;overflow:hidden;text-overflow:ellipsis}._17FowMHVqZopLsWoK31Sq_{background:#f4f5f7;color:#42526e}._17FowMHVqZopLsWoK31Sq_._3LnE6TZvekxWmQ-d8JZHMa{background:#dfe1e6;color:#253858}._43kspX48ZlFpCxyYtLtIM{background:#e3fcef;color:#064}._43kspX48ZlFpCxyYtLtIM._3LnE6TZvekxWmQ-d8JZHMa{background:#064;color:#fff}._2FExbVkX8JHmT-q6WsEvso{background:#ffebe6;color:#bf2600}._2FExbVkX8JHmT-q6WsEvso._3LnE6TZvekxWmQ-d8JZHMa{background:#bf2600;color:#fff}._3oABJUwYVA1yCSAo6oBBMl{background:#deebff;color:#0049b0}._3oABJUwYVA1yCSAo6oBBMl._3LnE6TZvekxWmQ-d8JZHMa{background:#0049b0;color:#fff}._3IEKGIIFrgJOZC_u3CF90u{background:#eae6ff;color:#403294}._3IEKGIIFrgJOZC_u3CF90u._3LnE6TZvekxWmQ-d8JZHMa{background:#403294;color:#fff}._1UUkKuA7m90IqJlt3MMffp{background:#fffae6;color:#344563}._1UUkKuA7m90IqJlt3MMffp._3LnE6TZvekxWmQ-d8JZHMa{background:#ff8b00;color:#344563}", "" ]), 
    // exports
    exports.locals = {
        lozenge: "_1L7JuuVj2lrlA-uLiXZjNZ",
        lozenge: "_1L7JuuVj2lrlA-uLiXZjNZ",
        content: "_2PDIjPIcgtZboLS2A1XsP6",
        content: "_2PDIjPIcgtZboLS2A1XsP6",
        default: "_17FowMHVqZopLsWoK31Sq_",
        default: "_17FowMHVqZopLsWoK31Sq_",
        bold: "_3LnE6TZvekxWmQ-d8JZHMa",
        bold: "_3LnE6TZvekxWmQ-d8JZHMa",
        success: "_43kspX48ZlFpCxyYtLtIM",
        success: "_43kspX48ZlFpCxyYtLtIM",
        removed: "_2FExbVkX8JHmT-q6WsEvso",
        removed: "_2FExbVkX8JHmT-q6WsEvso",
        inprogress: "_3oABJUwYVA1yCSAo6oBBMl",
        inprogress: "_3oABJUwYVA1yCSAo6oBBMl",
        new: "_3IEKGIIFrgJOZC_u3CF90u",
        new: "_3IEKGIIFrgJOZC_u3CF90u",
        moved: "_1UUkKuA7m90IqJlt3MMffp",
        moved: "_1UUkKuA7m90IqJlt3MMffp"
    };
}, /* 16 */
/***/
function(module, exports) {
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    // css base code, injected by the css-loader
    module.exports = function() {
        var list = [];
        // return the list of modules as css string
        // import a list of modules into the list
        return list.toString = function() {
            for (var result = [], i = 0; i < this.length; i++) {
                var item = this[i];
                item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
            }
            return result.join("");
        }, list.i = function(modules, mediaQuery) {
            "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
            for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
                var id = this[i][0];
                "number" == typeof id && (alreadyImportedModules[id] = !0);
            }
            for (i = 0; i < modules.length; i++) {
                var item = modules[i];
                // skip already imported module
                // this implementation is not 100% perfect for weird media query combinations
                //  when a module is imported multiple times with different media queries.
                //  I hope this will never occur (Hey this way we have smaller bundles)
                "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
                list.push(item));
            }
        }, list;
    };
}, /* 17 */
/***/
function(module, exports, __webpack_require__) {
    function addStylesToDom(styles, options) {
        for (var i = 0; i < styles.length; i++) {
            var item = styles[i], domStyle = stylesInDom[item.id];
            if (domStyle) {
                domStyle.refs++;
                for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
                for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
            } else {
                for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
                stylesInDom[item.id] = {
                    id: item.id,
                    refs: 1,
                    parts: parts
                };
            }
        }
    }
    function listToStyles(list) {
        for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
            var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
                css: css,
                media: media,
                sourceMap: sourceMap
            };
            newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
                id: id,
                parts: [ part ]
            });
        }
        return styles;
    }
    function insertStyleElement(options, styleElement) {
        var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
        if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
        styleElementsInsertedAtTop.push(styleElement); else {
            if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
            head.appendChild(styleElement);
        }
    }
    function removeStyleElement(styleElement) {
        styleElement.parentNode.removeChild(styleElement);
        var idx = styleElementsInsertedAtTop.indexOf(styleElement);
        idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
    }
    function createStyleElement(options) {
        var styleElement = document.createElement("style");
        return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
        styleElement;
    }
    function createLinkElement(options) {
        var linkElement = document.createElement("link");
        return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
        linkElement;
    }
    function addStyle(obj, options) {
        var styleElement, update, remove;
        if (options.singleton) {
            var styleIndex = singletonCounter++;
            styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
            update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
        } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
        update = updateLink.bind(null, styleElement), remove = function() {
            removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
        }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
        remove = function() {
            removeStyleElement(styleElement);
        });
        return update(obj), function(newObj) {
            if (newObj) {
                if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
                update(obj = newObj);
            } else remove();
        };
    }
    function applyToSingletonTag(styleElement, index, remove, obj) {
        var css = remove ? "" : obj.css;
        if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
            var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
            childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
        }
    }
    function applyToTag(styleElement, obj) {
        var css = obj.css, media = obj.media;
        if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
            for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
            styleElement.appendChild(document.createTextNode(css));
        }
    }
    function updateLink(linkElement, obj) {
        var css = obj.css, sourceMap = obj.sourceMap;
        sourceMap && (// http://stackoverflow.com/a/26603875
        css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
        var blob = new Blob([ css ], {
            type: "text/css"
        }), oldSrc = linkElement.href;
        linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
    }
    /*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
    var stylesInDom = {}, memoize = function(fn) {
        var memo;
        return function() {
            return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
        };
    }, isOldIE = memoize(function() {
        return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
    }), getHeadElement = memoize(function() {
        return document.head || document.getElementsByTagName("head")[0];
    }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
    module.exports = function(list, options) {
        options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
        // tags it will allow on a page
        "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
        "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
        var styles = listToStyles(list);
        return addStylesToDom(styles, options), function(newList) {
            for (var mayRemove = [], i = 0; i < styles.length; i++) {
                var item = styles[i], domStyle = stylesInDom[item.id];
                domStyle.refs--, mayRemove.push(domStyle);
            }
            if (newList) {
                var newStyles = listToStyles(newList);
                addStylesToDom(newStyles, options);
            }
            for (var i = 0; i < mayRemove.length; i++) {
                var domStyle = mayRemove[i];
                if (0 === domStyle.refs) {
                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
                    delete stylesInDom[domStyle.id];
                }
            }
        };
    };
    var replaceText = function() {
        var textStore = [];
        return function(index, replacement) {
            return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
        };
    }();
} ]);


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/@atlaskit/lozenge/dist/bundle-cjs.js
// module id = 177
// module chunks = 0